<template>
	<v-row>
		<v-col cols="12">
			<h2 class="text-left">
				Drop collection by Date
			</h2>
		</v-col>
		<v-col cols="3">
			<v-menu
				ref="menuFrom"
				v-model="menuFrom"
				:close-on-content-click="false"
				:return-value.sync="dateFrom"
				transition="scale-transition"
				offset-y
				min-width="290px">
				<template v-slot:activator="{ on }">
					<v-text-field
						v-model="dateFrom"
						label="Date from"
						prepend-icon="mdi-calendar"
						readonly
						outlined
						dense
						v-on="on"
					></v-text-field>
				</template>
				<v-date-picker v-model="dateFrom" no-title scrollable>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="menuFrom = false">Cancel</v-btn>
					<v-btn text color="primary" @click="$refs.menuFrom.save(dateFrom)">OK</v-btn>
				</v-date-picker>
			</v-menu>
		</v-col>
<!--		<v-col cols="3">-->
<!--			<v-menu-->
<!--				ref="menuTo"-->
<!--				v-model="menuTo"-->
<!--				:close-on-content-click="false"-->
<!--				:return-value.sync="dateTo"-->
<!--				transition="scale-transition"-->
<!--				offset-y-->
<!--				min-width="290px">-->
<!--				<template v-slot:activator="{ on }">-->
<!--					<v-text-field-->
<!--						v-model="dateTo"-->
<!--						label="Date to"-->
<!--						prepend-icon="mdi-calendar"-->
<!--						readonly-->
<!--						outlined-->
<!--						dense-->
<!--						v-on="on"-->
<!--					></v-text-field>-->
<!--				</template>-->
<!--				<v-date-picker v-model="dateTo" no-title scrollable>-->
<!--					<v-spacer></v-spacer>-->
<!--					<v-btn text color="primary" @click="menuTo = false">Cancel</v-btn>-->
<!--					<v-btn text color="primary" @click="$refs.menuTo.save(dateTo)">OK</v-btn>-->
<!--				</v-date-picker>-->
<!--			</v-menu>-->
<!--		</v-col>-->
		<v-col cols="3">
			<v-select
				:items="['sections', 'sessions', 'plans']"
				v-model="collection"
				label="Collection"
				outlined
				dense
			></v-select>
		</v-col>
		<v-col cols="2" class="text-left">
			<v-btn color="error" @click="drop" :disabled="!collection">
				Drop
			</v-btn>
		</v-col>
	</v-row>
</template>

<script>
	import { db } from './../db';

	const plans = db.collection('plans');
	const sessions = db.collection('sessions');
	const sections = db.collection('sections');

	export default {
		data: () => ({
			dateFrom: new Date().toISOString().substr(0, 10),
			dateTo: '',
			collection: '',
			menuFrom: false,
			menuTo: false,
			sessions: [],
			sections: [],
			plans: []
		}),
		methods:{
			async drop(){
				this.$bind(
					this.collection, db.collection(this.collection)
						.where('createDate', '>=', new Date(this.dateFrom).getTime())
						// .where('createDate', '<=', new Date(this.dateTo).getTime())
				).then( (resp) => this.dropCollection(resp) )
			},
			async dropCollection(arr){
				this.$emit('inProgress', true);
				const promises = arr.map( el => {
					return new Promise(resolve => {
						switch (this.collection) {
							case 'sections':
								sections.doc(el.id).delete().then(() => resolve(true));
								break;
							case 'sessions':
								sessions.doc(el.id).delete().then(() => resolve(true));
								break;
							case 'plans':
								plans.doc(el.id).delete().then(() => resolve(true));
								break;
						}
					})
				});

				await Promise.all(promises);
				this.$emit('inProgress', false);

				this.$notify({
					group: 'system',
					type: 'success',
					title: 'Great!',
					text: `Collection ${this.collection} has been dropped!`
				});
			}
		},
	}
</script>
